import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { CreditTransaction } from "services/factoryCreditApi";
import { formatDateWithTime } from "utils/dateFormat";
import { isCodFailOrderReleaseRow } from "utils/creditTransactionDisplay";
import { systemTypeLabel } from "./creditTransactionOptions";

const HEADER = [
  "วันเวลา",
  "รายการ",
  "เลขที่ทำรายการ",
  "เลขพัสดุ",
  "ระบบ",
  "รับ",
  "จ่าย",
  "คงเหลือ",
];

const fileBaseName = (): string => {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  return `credit_transactions_${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(
    d.getHours()
  )}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
};

const roundOrEmpty = (n: number | null | undefined): number | "" => {
  if (n == null || !Number.isFinite(Number(n)) || Number(n) === 0) return "";
  return Math.round(Number(n));
};

const remainingCell = (row: CreditTransaction): number | "" => {
  if (row.remaining_after_display != null && Number.isFinite(Number(row.remaining_after_display))) {
    return Math.round(Number(row.remaining_after_display));
  }
  if (row.quota_after != null && Number.isFinite(Number(row.quota_after))) {
    return Math.round(Number(row.quota_after));
  }
  return "";
};

export function exportCreditTransactionsExcel(rows: CreditTransaction[]): void {
  const body = rows
    .filter((row) => !isCodFailOrderReleaseRow(row) && !row.is_grouped_duplicate)
    .map((row) => {
    const signed = Number(row.amount_display ?? 0);
    const debit =
      row.debit_display != null
        ? roundOrEmpty(row.debit_display)
        : signed < 0
          ? Math.round(Math.abs(signed))
          : "";
    const credit =
      row.credit_display != null
        ? roundOrEmpty(row.credit_display)
        : signed > 0
          ? Math.round(signed)
          : "";
    return [
      row.create_date ? formatDateWithTime(row.create_date) : "",
      row.display_label_th ?? "",
      row.ref_display_no ?? "",
      row.tracking_number ?? "",
      systemTypeLabel(row.system_type),
      credit,
      debit,
      remainingCell(row),
    ];
  });

  const ws = XLSX.utils.aoa_to_sheet([HEADER, ...body]);
  ws["!cols"] = [
    { wch: 18 },
    { wch: 48 },
    { wch: 20 },
    { wch: 18 },
    { wch: 18 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "ความเคลื่อนไหวเครดิต");
  const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${fileBaseName()}.xlsx`);
}
